<div class="sidebar-toggle-bar d-lg-none">
  <button
    class="sidebar-toggle"
    type="button"
    aria-controls="appSidebar"
    [attr.aria-expanded]="menuOpen"
    aria-label="Toggle navigation"
    (click)="toggleMenu()"
  >
    <span class="sidebar-toggle__icon"></span>
  </button>
  <span class="sidebar-toggle__brand">Workflow</span>
</div>

<div class="sidebar-overlay" [class.is-open]="menuOpen" (click)="closeMenu()"></div>

<aside class="app-sidebar" id="appSidebar" [class.is-open]="menuOpen">
  <div class="sidebar-header">
    <span class="sidebar-brand">Workflow</span>
  </div>

  <nav class="sidebar-nav">
    <a
      class="nav-link"
      routerLink="/"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="closeMenu()"
    >
      <span class="nav-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M4 10.5L12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5Z"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <span>Home</span>
    </a>

    <a class="nav-link" routerLink="/crm" routerLinkActive="active" (click)="closeMenu()">
      <span class="nav-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M6 7h12M6 12h12M6 17h6"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
          />
          <path
            d="M16 17h3a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h1"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <span>Orçamento</span>
    </a>

    <a class="nav-link" routerLink="/workflow" routerLinkActive="active" (click)="closeMenu()">
      <span class="nav-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M4 6h6v6H4V6Zm10 0h6v6h-6V6ZM4 16h6v4H4v-4Zm10 0h6v4h-6v-4Z"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <span>Workflow</span>
    </a>

    <a class="nav-link" routerLink="/dashboards" routerLinkActive="active" (click)="closeMenu()">
      <span class="nav-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M5 18V9m7 9V6m7 12v-7"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
          />
          <path d="M4 18h16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
        </svg>
      </span>
      <span>Dashboards</span>
    </a>

    <div class="reports-section">
      <div class="nav-group">
        <div class="nav-group__title">Relatórios de Gestão</div>
        <a
          class="nav-link"
          routerLink="/relatorios/gestao/funil-orcamentos"
          routerLinkActive="active"
          (click)="closeMenu()"
        >
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M4 5h16l-6 7v5l-4 2v-7L4 5Z"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span>Funil de Orçamentos</span>
        </a>
        <a
          class="nav-link"
          routerLink="/relatorios/gestao/sla-producao"
          routerLinkActive="active"
          (click)="closeMenu()"
        >
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.6" />
              <path
                d="M12 7v5l3 2"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span>SLA de Produção</span>
        </a>
        <a
          class="nav-link"
          routerLink="/relatorios/gestao/wip-capacidade"
          routerLinkActive="active"
          (click)="closeMenu()"
        >
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M5 8h14M7 12h10M9 16h6"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span>Produção e Capacidade</span>
        </a>
      </div>

      <div class="nav-group">
        <div class="nav-group__title">Relatórios de Processo</div>
        <a
          class="nav-link"
          routerLink="/relatorios/processo/tempo-por-etapa"
          routerLinkActive="active"
          (click)="closeMenu()"
        >
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M4 6h4v4H4V6Zm6 4h4v4h-4v-4Zm6 4h4v4h-4v-4Z"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linejoin="round"
              />
              <path
                d="M8 8h2m4 4h2m4 4h2"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span>Tempo por Etapa</span>
        </a>
        <!-- <a
          class="nav-link"
          routerLink="/relatorios/processo/dias-parado"
          routerLinkActive="active"
          (click)="closeMenu()"
        >
          <span class="nav-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M7 6v12M17 6v12"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
              />
              <rect
                x="4"
                y="4"
                width="16"
                height="16"
                rx="4"
                stroke="currentColor"
                stroke-width="1.6"
              />
            </svg>
          </span>
          <span>Dias parado</span>
        </a> -->
      </div>
    </div>
  </nav>
</aside>
